import React, {RefObject} from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import "./c49_map.scss";
import {FormGroup} from "@material-ui/core";
import {TFunction} from "i18next";
import LuissCheckbox from "../../common_components/luiss_checkbox/luiss_checkbox";
import Slider from "react-slick";
import ReactDOM from "react-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Card} from "react-bootstrap";
import GoogleMap from "google-map-react";
import LuissMapMarker, {LuissMapMarkerData} from "./luiss_map/luiss_map_marker";
import axios from "axios";
import {isMobileOnly} from "react-device-detect";
import {insertHtml} from "../../utils/dom";


const luissMapStyles = [
    {
        "featureType": "all",
        "stylers": [
            {
                "saturation": 0
            },
            {
                "hue": "#e7ecf0"
            }
        ]
    },
    {
        "featureType": "road",
        "stylers": [
            {
                "saturation": -70
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "saturation": -60
            }
        ]
    }
];

interface C49MapData {
    cards: any;
}

class C49Map extends TemplateComponent<C49MapData>  {

    private cardsRefs?: RefObject<any>[];
    private slider: any;

    constructor(props: TemplateComponentProps<C49MapData>) {
        super(props);

        this.requireInternationalization = true;

        this.state = {...this.state, ...{
                showDetails: {
                    targetId: null
                },
                targetId:'',
                hideElem: '',
                dataIndex: null,
                showResidenze: true,
                showCollegi: true,
                active: 0,
                next: 0,
                slideIndex: 1,
                updateCount: 0
            }
        };
        this.showContent = this.showContent.bind(this);
        this.hideContent= this.hideContent.bind(this);
        this.filterCard= this.filterCard.bind(this);
    }


    showContent(e:any) {
        this.setState({ showDetails: { targetId: Number(e.currentTarget.dataset.id)}, hideElem: 'hide'})
    }

    hideContent () {
        this.setState({ showDetails: { targetId: null}, hideElem: ''})
    }

    filterCard(e:any){

        const ep:any = this.props.url;
        const filterData: any = [];
        let val = e.target.value.toString();

        if (!e.target.checked){
            if(val === 'collegi'){val = 'residenza'; this.setState({ showCollegi: !this.state.showCollegi })}
            if(val === 'residenze'){val = 'collegio'; this.setState({ showResidenze: !this.state.showResidenze })}
        }else{
            if(val === 'collegi'){val = 'collegio'; this.setState({ showCollegi: !this.state.showCollegi })}
            if(val === 'residenze'){val = 'residenza'; this.setState({ showResidenze: !this.state.showResidenze })}
        }

        axios.get(ep, {}).then(res => {
            if((!this.state.showCollegi && !this.state.showResidenze) ||
                (this.state.showCollegi && this.state.showResidenze)){
                this.setState({data: res.data, card: res.data.cards})
            }else{
                res.data.cards.forEach((filterString:any) => {
                    for (var key in filterString){
                        if(filterString[key] === val){
                            filterData.push(filterString);
                            this.setState({
                                data: {...this.state.data, cards: filterData}
                            });
                        }
                    }
                })
            }
        });
    }

    internationalComponentRender(data: C49MapData, t: TFunction): React.ReactElement<any> {

        // Return map bounds based on list of places
        const getMapBounds = (map:any, maps:any, places:any) => {
            const bounds = new maps.LatLngBounds();

            places.forEach((place:any) => {
                bounds.extend(new maps.LatLng(
                    place.lat,
                    place.lng,
                ));
            });
            return bounds;
        };

        // Re-center map when resizing the window
        const bindResizeListener = (map:any, maps:any, bounds:any) => {
            maps.event.addDomListenerOnce(map, 'idle', () => {
                maps.event.addDomListener(window, 'resize', () => {
                    map.fitBounds(bounds);
                });
            });
        };

        //Google API Load
        const handleApiLoaded = (map:any, maps:any) => {
            //console.log(map, maps)
            const bounds = getMapBounds(map, maps, places);
            // Fit map to bounds
            map.fitBounds(bounds);
            // Bind the resize listener
            bindResizeListener(map, maps, bounds);
        };


        let places:any = [];
        const sliderSettings = {
            dots: false,
            variableWidth: true,
            centerMode: false,
            rows: 1,
            infinite: true,
            arrows: true,
            beforeChange: (currIndex: number, nextIndex: number) => {
                // We cannot change the state, or the rerender won't let the slider component to work properly
                if (this.cardsRefs && this.cardsRefs[nextIndex]) {
                    let nextCard = (ReactDOM.findDOMNode(this.cardsRefs[nextIndex].current) as Element);
                    nextCard.classList.add("active");
                }
            },
            afterChange: (index: number) => {
                this.setState({active: index, next: null, slideIndex: this.state.updateCount + (index + 1)});
            }
        };

        if (!this.cardsRefs) {
            this.cardsRefs = data.cards.map(() => React.createRef());
        }
        return (
            <div className="c49-map">
                <div className="filters-row">

                    <FormGroup row className="filters-group">
                        <LuissCheckbox
                            checked={this.state.showResidenze}
                            onChange={this.filterCard}
                            value="residenze"
                            label={t("C49 filters residenze")}
                        />
                        <LuissCheckbox
                            checked={this.state.showCollegi}
                            onChange={this.filterCard}
                            value="collegi"
                            label={t("C49 filters collegi")}
                        />
                    </FormGroup>
                </div>
                <div className="map-row">
                    {/* Create Array with coordinates for every item */}
                    {
                        // eslint-disable-next-line array-callback-return
                        this.state.data.cards.map((el:any, i:number) => {
                            places.push({lat: Number(el.lat), lng: Number(el.lng), onMarkerClick: () => {console.log(i)}})
                        })
                    }
                    {/* Init Google Map */}
                    <GoogleMap
                        bootstrapURLKeys={{
                            key: "AIzaSyC8foqBVORUNZmk1RhGs0n8k5uK1RoLZRI"
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                        defaultZoom={0}
                        defaultCenter={{
                            lat: Number(places[0].lat),
                            lng: Number(places[0].lng)

                        }}
                        options={{
                            styles: luissMapStyles
                        }}
                    >
                    {/* Place marker */}
                        {
                            places.map((place: LuissMapMarkerData, index:number) =>
                                <LuissMapMarker key={index} lat={place.lat} lng={place.lng} onMarkerClick={place.onMarkerClick}/>
                            )
                        }
                    </GoogleMap>
                </div>
                <div data-id="Slider" className="cards-row offset-top">
                    <Slider ref={slider => (this.slider = slider)} className="navigation-slider-small-card" {...sliderSettings}>
                        {
                            this.state.data.cards.map((cardData: any, index: number) =>
                                <div data-aos="fade-up-left" data-aos-offset="50" key={`card-animation-${index}`}>
                                    {/* Start Card */}
                                    <Card key={index} className={cardData.type + (this.state.showDetails.targetId === index ? " open" : '')} ref={this.cardsRefs![index]}>
                                        <Card.Body>

                                            {(this.state.showDetails.targetId === index) &&
                                                <>
                                                    <div className={"popup-button-container" + (!cardData.image ? " btn-relative" : '')} onClick={this.hideContent} >
                                                        <div className="popup-button" />
                                                    </div>
                                                    {(cardData.image) ? <div className={"img-content"}><img src={cardData.image} alt={'Luiss.it'}/></div> : null}
                                                </>
                                            }
                                            <Card.Title>{cardData.title}</Card.Title>
                                            {(this.state.showDetails.targetId === index) &&
                                                <>
                                                <div className={'sub-content'} {...insertHtml(cardData.content)}/>
                                                {(cardData.web_link) &&
                                                    <Card.Link className={'show-more-link'} href={cardData.web_link}>{cardData.web_cta}</Card.Link>
                                                }
                                                </>
                                            }
                                            {(this.state.showDetails.targetId === index && this.state.hideElem === 'hide') ?
                                                true
                                            : <>
                                                <Card.Text>{cardData.address}</Card.Text>
                                                {(cardData.phone) &&
                                                <div>{cardData.phone}</div>
                                                }
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <a onClick={this.showContent} data-id={index}>{cardData.show_more_cta}</a>
                                              </>
                                            }

                                        </Card.Body>
                                    </Card>
                                    {/* End Card */}

                                </div>

                            )
                        }
                    </Slider>
                    {this.state.data.cards.map((cardData: any, index: number) =>
                        <>
                            {/* Start Card Open Mobile*/}
                            {(isMobileOnly && this.state.showDetails.targetId === index) &&
                                <div id="mob-overlay-card">

                                    <div className={"popup-button-container" + (!cardData.image ? " btn-relative" : '')} onClick={this.hideContent} >
                                        <div className="popup-button" />
                                    </div>
                                    {(cardData.image) && <div className={"img-content"}><img src={cardData.image} alt={'Luiss.it'}/></div>}

                                    <div className={"wrapper-content"}>
                                        <Card.Title>{cardData.title}</Card.Title>
                                        <div className={'sub-content'} {...insertHtml(cardData.content)} />
                                        {(cardData.web_link) &&
                                            <Card.Link className={'show-more-link'} href={cardData.web_link}>{cardData.web_cta}</Card.Link>
                                        }
                                    </div>

                                </div>
                            }
                            {/* End Card Open Mobile*/}
                        </>
                    )}

                    <div className="container-range-slider">
                        <input
                            className="progressive-slider-small-card"
                            onChange={event => this.slider.slickGoTo(event.target.value)}
                            value={this.state.slideIndex}
                            type="range"
                            min="1"
                            max={data.cards.length}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default C49Map;
